import { BaseApi } from './base';

class MaterialsApi extends BaseApi {
  constructor() {
    super('materials');
  }

  getModels() {
    return this.get('');
  }

  getAppointments() {
    return this.get('/appointments');
  }

  getTypes() {
    return this.get('/types');
  }

  getLevels() {
    return this.get('/levels');
  }
}

export default new MaterialsApi();
